import { CheckCircle2, Loader2, XCircle } from 'lucide-react'
import { FileUploadStatus } from '../../../hooks/useDocumentUpload'

type DoneStepProps = {
  files: { title: string; status: FileUploadStatus; errorMessage: string | null }[]
  isComplete: boolean
}

const STATUS_ICON: Record<FileUploadStatus, React.ReactNode> = {
  idle: <Loader2 className="h-4 w-4 text-muted-foreground" />,
  uploading: <Loader2 className="h-4 w-4 animate-spin text-primary" />,
  success: <CheckCircle2 className="h-4 w-4 text-green-600" />,
  error: <XCircle className="h-4 w-4 text-destructive" />,
}

export const DoneStep = ({ files, isComplete }: DoneStepProps) => {
  const succeeded = files.filter((f) => f.status === 'success').length
  const failed = files.filter((f) => f.status === 'error').length

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h3 className="text-lg font-semibold">{isComplete ? 'Upload complete' : 'Uploading…'}</h3>
        {isComplete && (
          <p className="text-sm text-muted-foreground">
            {succeeded} of {files.length} document{files.length === 1 ? '' : 's'} uploaded
            {failed > 0 ? `, ${failed} failed` : ''}.
          </p>
        )}
      </div>

      <ul className="flex flex-col gap-2">
        {files.map((file, index) => (
          <li
            key={index}
            className="flex items-center justify-between rounded-md border px-3 py-2 text-sm"
          >
            <div>
              <p className="font-medium">{file.title}</p>
              {file.status === 'error' && file.errorMessage && (
                <p className="text-xs text-destructive">{file.errorMessage}</p>
              )}
            </div>
            {STATUS_ICON[file.status]}
          </li>
        ))}
      </ul>
    </div>
  )
}
